exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nth.column-money,\ntd.column-money {\n  text-align: right !important;\n}\n", ""]);

// exports
